import React, { useEffect, useState } from 'react';
import '../css/Objective.css';

const Objective2: React.FC = () => {
    const [visibleDivs, setVisibleDivs] = useState<number>(0);

    useEffect(() => {
        const interval = setInterval(() => {
            setVisibleDivs((prev: any) => {
                if (prev < 3) {
                    return prev + 1;
                } else {
                    clearInterval(interval);
                    return prev;
                }
            });
        }, 800);
        return () => clearInterval(interval);
    }, []);
    return (
        <div className="objective">
            <div className="objective2-content">
                <div className="objective-description-bottom">
                    <div
                        className={`objective-block ${visibleDivs >= 1 ? 'visible' : ''}`}
                        style={{
                            backgroundImage: `url(${process.env.PUBLIC_URL + '/objective1.jpg'})`,
                            backgroundColor: `rgba(0, 0, 0, 0.5)`,
                            backgroundBlendMode: 'multiply',
                            backgroundSize: 'cover',
                            backgroundRepeat: 'no-repeat',
                            backgroundOrigin: 'border-box',
                            backgroundPosition: 'center',
                            overflow: 'hidden',
                        }}
                    >
                        <br></br>
                        <div className="objective-block-title">
                            <div style={{ fontSize: '1.4rem', fontWeight: 'bold' }}>Stable and high profitability</div>
                            안정적이며 큰 수익성
                            <br />
                            <br />
                            <br />
                            ──────
                        </div>

                        <div className="objective-block-description">
                            <br />
                            AI 자동거래 기술과 전문성을 바탕으로
                            <br />
                            최적의 트레이딩 솔루션을 제공하여
                            <br />
                            전략적이고 안정적인 방법을 제시합니다
                        </div>
                    </div>
                    <div
                        className={`objective-block ${visibleDivs >= 2 ? 'visible' : ''}`}
                        style={{
                            backgroundImage: `url(${process.env.PUBLIC_URL + '/objective2.jpg'})`,
                            backgroundColor: `rgba(0, 0, 0, 0.5)`,
                            backgroundBlendMode: 'multiply',
                            backgroundSize: 'cover',
                            backgroundRepeat: 'no-repeat',
                            backgroundOrigin: 'border-box',
                            backgroundPosition: 'center',
                            overflow: 'hidden',
                        }}
                    >
                        <br></br>
                        <div className="objective-block-title">
                            <div style={{ fontSize: '1.4rem', fontWeight: 'bold' }}>
                                An easy-to-learn <br />
                                investment method
                            </div>
                            누구나 쉽게 배울 수 있는 투자방법
                            <br />
                            <br />
                            ──────
                        </div>
                        <div className="objective-block-description">
                            <br />
                            메뉴얼 트레이딩 교육을 통해
                            <br />
                            누구나 쉽게 이해하고 적용할 수 있도록
                            <br />
                            접근성 높은 거래방법을 교육합니다
                        </div>
                    </div>
                    <div
                        className={`objective-block ${visibleDivs >= 3 ? 'visible' : ''}`}
                        style={{
                            backgroundImage: `url(${process.env.PUBLIC_URL + '/objective3.jpg'})`,
                            backgroundColor: `rgba(0, 0, 0, 0.5)`,
                            backgroundBlendMode: 'multiply',
                            backgroundSize: 'cover',
                            backgroundRepeat: 'no-repeat',
                            backgroundOrigin: 'border-box',
                            backgroundPosition: 'center',
                            overflow: 'hidden',
                        }}
                    >
                        <br></br>
                        <div className="objective-block-title">
                            <div style={{ fontSize: '1.4rem', fontWeight: 'bold' }}>A steady wealth account</div>
                            은퇴없는 꾸준한 재테크 통장
                            <br />
                            <br />
                            <br />
                            ──────
                        </div>
                        <div className="objective-block-description">
                            <br />
                            AI 트레이딩 프로그램을 통해
                            <br />
                            데이터를 빠르게 분석하고 리스크를 관리하여
                            <br />
                            투자 성과를 지원합니다
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Objective2;
